/**
 * Generic agent config writer — for Agent Skills-compatible tools
 * not explicitly supported (e.g., Aider, Continue, Roo, etc.).
 *
 * Only installs the cross-client skill to ~/.agents/skills/.
 * No MCP configuration (unknown config format).
 */

import { installCrossClientSkill, removeCrossClientSkill, type AgentConfigWriter } from "./base.js";

export const generic: AgentConfigWriter = {
  id: "generic",
  name: "Generic (Agent Skills)",

  installSkill(global: boolean): void {
    installCrossClientSkill(global);
  },

  installMcp(): void {
    // No-op: unknown MCP config format for generic agents.
    // The cross-client skill at ~/.agents/skills/ is sufficient for
    // any Agent Skills-compatible tool.
  },

  uninstallSkill(): void {
    removeCrossClientSkill(true);
  },

  uninstallMcp(): void {
    // No-op
  },
};
